import { ArrowLeftOutlined } from '@ant-design/icons';
import { updateProfile } from 'firebase/auth';
import React, { useContext, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { useHistory } from 'react-router-dom';

import { Context } from '../../../index';

const Profile = ({ setPage }) => {
  const history = useHistory();
  const { auth, firestore } = useContext(Context);
  const [user] = useAuthState(auth);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [users] = useCollectionData(firestore.collection('users').where('uid', '===', user.uid));

  const sendUser = async () => {
    if (!users?.length) {
      await updateProfile(auth.currentUser, {
        displayName: firstName + lastName,
      });
      await firestore.collection('users').add({
        uid: user.uid,
        firstName,
        lastName,
        role: 'user',
      });
    }
    history.push('/rooms');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
      <h3 className="profile__article">
        <button className="arrow" type="button" onClick={() => setPage('verification')}>
          <ArrowLeftOutlined style={{ fontSize: '16px', color: 'black', marginRight: '20px' }} />
        </button>
        Profile information
      </h3>
      <p className="profile__text">About you</p>
      <div>
        <div>
          <input
            className="profile__field"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>
        <div>
          <input
            className="profile__field"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>
      </div>
      <button className="btn" type="button" onClick={() => sendUser()}>
        Continue
      </button>
    </div>
  );
};

export default Profile;
